import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import { env } from '../env';

export const initializeDatadog = () => {
  if (env.REACT_APP_DATADOG_ENV != 'local') {
    datadogRum.init({
      allowedTracingUrls: [env.RAD_APP_API_URL, env.RAD_FUNCTION_APP_URL].filter(
        url => typeof url === 'string' && /^https?:\/\//.test(url),
      ),
      //Reason why RAD use Local Storage instead of Cookies for _dd_s session persistence:
      // AceNet writes _dd_s on its parent domain (.aceservices.com /
      // .npaceservices.com) so its iframe children share the session. RAD is
      // on the same parent domain but is NOT iframed inside AceNet, so the
      // shared cookie collides with RAD's SDK — getInternalContext() returns
      // undefined and no RUM events are sent when AceNet is open. localStorage
      // is origin-scoped, so RAD's session cannot collide with AceNet's.
      sessionPersistence: 'local-storage',
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      applicationId: '2ea48958-a94f-4e65-a65f-2dfd08bca593',
      clientToken: 'pub06f634c58a8aeb0e6e621a044c9bffb8',
      site: 'us3.datadoghq.com',
      service: 'rad-dashboard-ui',
      env: env.REACT_APP_DATADOG_ENV,
      sessionSampleRate: Number(env.REACT_APP_DATADOG_SESSION_SAMPLE_RATE),
      sessionReplaySampleRate: Number(env.REACT_APP_DATADOG_REPLAY_SAMPLE_RATE),
      defaultPrivacyLevel: 'mask-user-input',
      plugins: [reactPlugin({ router: true })],
    });
  }
};
